import { render, staticRenderFns } from "./SettingRunTime.vue?vue&type=template&id=3d48aa2d&scoped=true"
import script from "./SettingRunTime.vue?vue&type=script&lang=js"
export * from "./SettingRunTime.vue?vue&type=script&lang=js"
import style0 from "./SettingRunTime.vue?vue&type=style&index=0&id=3d48aa2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d48aa2d",
  null
  
)

export default component.exports